import { render, staticRenderFns } from "./FormsSegregovaneKomunityPo.vue?vue&type=template&id=0a8fee74&"
import script from "./FormsSegregovaneKomunityPo.vue?vue&type=script&lang=js&"
export * from "./FormsSegregovaneKomunityPo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports